<!-- STANDARD Modal Header (SuperPrompt V9) -->
<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body (SuperPrompt V9) -->
<div class="modal-body" [hidden]="minimise">
  <!-- Loader -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <!-- Entity information table -->
    <table class="table table-bordered form-inline enityDetails custom-table">
      <tr>
        @for (item of entityList; track $index) {
<td>
          <span><strong>{{ item.key }}</strong></span>
        </td>
}
      </tr>
      <tr>
        @for (item of entityList; track $index) {
<td>
          <span>{{ item.value }}</span>
        </td>
}
      </tr>
    </table>

    <!-- Name of Partnership and EIN -->
    @if (scheduleB2Data['NA']) {
<table class="table table-bordered form-inline custom-table">
      <thead>
        <tr>
          <th>Name of Partnership</th>
          <th>Employer Identification Number (EIN)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <input class="form-control input-md input-text-left"
                   style="width: 100%;"
                   type="text"
                   [(ngModel)]="scheduleB2Data['NA'][0].ATTRIB_VALUE"
                   readonly>
          </td>
          <td>
            <input class="form-control input-md input-text-left"
                   style="width: 100%;"
                   type="text"
                   [(ngModel)]="scheduleB2Data['NA'][1].ATTRIB_VALUE"
                   readonly>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <span class="b2-instruction">
              Certain partnerships with 100 or fewer partners can elect out of the centralized partnership audit regime if each partner is an individual,
              a C corporation, a foreign entity that would be treated as a C corporation were it domestic, an S corporation, or an estate of a deceased
              partner. For purposes of determining whether the partnership has 100 or fewer partners, the partnership must include all shareholders of
              any S corporation that is a partner. By completing Part I, you are making an affirmative statement that all of the partners in the
              partnership are eligible partners under section 6221(b)(1)(C) and you have provided all of the information on this schedule. See the
              instructions, including the instructions for the treatment of real estate mortgage investment conduits (REMICs), for more details.
            </span>
          </td>
        </tr>
      </tbody>
    </table>
}

    <!-- Part I: List of Eligible Partners -->
    @if (scheduleB2Data['P1']) {
<table class="table table-bordered form-inline custom-table">
      <thead>
        <tr>
          <th colspan="3" class="part-header">
            <span class="b2-part">Part I</span> List of Eligible Partners
          </th>
        </tr>
        <tr>
          <th>Name of Partner</th>
          <th>Taxpayer Identification Number (TIN)</th>
          <th>Type of Eligible Partner (Code)</th>
        </tr>
      </thead>
      <tbody>
        @for (row of scheduleB2Data['P1']; track trackByIndex(i); let i = $index) {

          @if (i % 3 === 0) {
<tr>
            <td>{{ scheduleB2Data['P1'][i]?.ATTRIB_VALUE }}</td>
            <td>{{ scheduleB2Data['P1'][i+1]?.ATTRIB_VALUE }}</td>
            <td align="right">
              <select class="form-control" style="width:100%"
                      [(ngModel)]="scheduleB2Data['P1'][i+2].ATTRIB_VALUE"
                      (change)="part2Compute(scheduleB2Data['P1'][i].LEID, i)">
                <option value="">Select</option>
                @for (option of part1DropDown; track $index) {
<option [value]="option.value">{{option.label}}</option>
}
              </select>
            </td>
          </tr>
}
        
}
      </tbody>
    </table>
}

    <!-- Part II: List of S Corporation Shareholders (one table per S Corp) -->
    @for (key of getP2Keys(); track $index) {

      @if (scheduleB2Data['P2'][key]?.length > 0) {
<table class="table table-bordered form-inline custom-table">
        <thead>
          <tr>
            <th colspan="5" class="part-header">
              <span class="b2-part">Part II</span> List of S Corporation Shareholders
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Name of S Corporation Partner</td>
            <td>
              <input class="form-control input-md input-text-left"
                     style="width: 100%;"
                     type="text"
                     [ngModel]="scheduleB2Data['P2'][key][0]?.ATTRIB_VALUE"
                     readonly>
            </td>
            <td>TIN of Partner</td>
            <td colspan="2">
              <input class="form-control input-md input-text-left"
                     style="width: 100%;"
                     type="text"
                     [ngModel]="scheduleB2Data['P2'][key][1]?.ATTRIB_VALUE"
                     readonly>
            </td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th colspan="2" class="grey-header">Name of Shareholder</th>
            <th class="grey-header">Shareholder TIN</th>
            <th class="grey-header">Type of Person (Code)</th>
            <th class="add-row-header">
              <i class="fa fa-plus-circle color-green" (click)="addShareholder(scheduleB2Data['P2'][key][0])"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- Existing shareholders from Part 2 -->
          @for (row of scheduleB2Data['P2'][key]; track trackByIndex(j); let j = $index) {

            @if ((j + 1) % 3 === 0 && j >= 2) {
<tr>
              <td colspan="2">{{ scheduleB2Data['P2'][key][j]?.ATTRIB_VALUE }}</td>
              <td>{{ scheduleB2Data['P2'][key][j+1]?.ATTRIB_VALUE }}</td>
              <td align="right">
                <select class="form-control" style="width:100%"
                        [(ngModel)]="scheduleB2Data['P2'][key][j+2].ATTRIB_VALUE">
                  <option value="">Select</option>
                  @for (option of part2DropDown; track $index) {
<option [value]="option.value">{{option.label}}</option>
}
                </select>
              </td>
              <td></td>
            </tr>
}
          
}

          <!-- New shareholders (multirow_data) -->
          @if (multirow_data[scheduleB2Data['P2'][key][0]?.COMBINATION_KEY]) {

            @for (row of multirow_data[scheduleB2Data['P2'][key][0]?.COMBINATION_KEY]; track trackByIndex(k); let k = $index) {

              @if ((k + 1) % 3 === 0) {
<tr>
                <td colspan="2">
                  <input class="form-control input-md input-text-left" type="text" style="width: 100%;"
                         [(ngModel)]="multirow_data[scheduleB2Data['P2'][key][0]?.COMBINATION_KEY][k-2].ATTRIB_VALUE">
                </td>
                <td>
                  <input type="text" class="form-control input-sm input-text-left" style="width: 100%"
                         maxlength="9"
                         [(ngModel)]="multirow_data[scheduleB2Data['P2'][key][0]?.COMBINATION_KEY][k-1].ATTRIB_VALUE">
                </td>
                <td align="right">
                  <select class="form-control" style="width:100%"
                          [(ngModel)]="multirow_data[scheduleB2Data['P2'][key][0]?.COMBINATION_KEY][k].ATTRIB_VALUE">
                    <option value="">Select</option>
                    @for (option of part2DropDown; track $index) {
<option [value]="option.value">{{option.label}}</option>
}
                  </select>
                </td>
                <td style="cursor: pointer;">
                  <i class="fa fa-minus-circle color-red" 
                     (click)="removeShareHolder(scheduleB2Data['P2'][key][0]?.COMBINATION_KEY, k-2)"></i>
                </td>
              </tr>
}
            
}
          
}
        </tbody>
      </table>
}
    
}

    <!-- Part III: Total Number of Schedules K-1 -->
    @if (scheduleB2Data['P3']) {
<table class="table table-bordered form-inline custom-table">
      <thead>
        <tr>
          <th colspan="3" class="part-header">
            <span class="b2-part">Part III</span> Total Number of Schedules K-1 Required To Be Issued. 
            <span class="b2-instruction">See instructions</span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (row of scheduleB2Data['P3']; track trackByIndex(i); let i = $index) {
<tr>
          <td style="width: 58px">{{row.LINE_NO}}</td>
          <td>{{row.LINE_DESCRIPTION}}</td>
          <td style="width: 110px" align="right">
            <input class="form-control input-md"
                   type="text"
                   [(ngModel)]="row.ATTRIB_VALUE"
                   readonly>
          </td>
        </tr>
}
      </tbody>
    </table>
}
  </div>
}
</div>

<!-- STANDARD Footer (SuperPrompt V9) -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

